import React from "react";
import styled from "styled-components";
import { Card } from "reactstrap";
import Switch from "react-bootstrap-switch";
import FamiliesTable from "./FamiliesTable";
import FormulasTable from "./FormulasTable";


class FamiliesAndFormulas extends React.Component {
  state = {
    concreteFamiliesSelected: [],
    showInactiveFormulas: false,
    hasSelectedFamiliesOnce: false
  };

  onFamilySelected = (
    familyId,
    familyName,
    selected
  ) => this.setState(({
    concreteFamiliesSelected,
  }) => {
    const nextConcreteFamiliesSelected = selected
      ? concreteFamiliesSelected.concat({ id: familyId, name: familyName })
      : concreteFamiliesSelected.filter(({ id }) => id !== familyId);
    return {
      concreteFamiliesSelected: nextConcreteFamiliesSelected,
      hasSelectedFamiliesOnce:
        true
    };
  })

  onChangeInactiveFormulas = el => this.setState({ showInactiveFormulas: el.value() });

  render() {
    const {
      concreteFamiliesSelected,
      showInactiveFormulas,
      hasSelectedFamiliesOnce
    } = this.state;
    return (
      <div className="content">
        <Card>
          <FamiliesTable onFamilySelected={this.onFamilySelected} />
        </Card>
        {hasSelectedFamiliesOnce && (
          <React.Fragment>
            <Card style={{ marginTop: "5px", padding: "6px", alignItems: "center", display: "flex", flexDirection: "row" }}>
              <Title style={{ width: "auto", marginLeft: "5px", marginRight: "8px" }}>Mostrar Inativos</Title>
              <Switch
                offColor="info"
                offText=""
                onColor="info"
                onText=""
                value={showInactiveFormulas}
                onChange={this.onChangeInactiveFormulas}
                style={{ marginBottom: "0px" }}
                width="100px"
              />
            </Card>
            {concreteFamiliesSelected.length > 0 && (
              <Card style={{ marginTop: "25px" }}>
                <FormulasTable
                  concreteFamiliesSelected={concreteFamiliesSelected}
                  showInactiveFormulas={showInactiveFormulas}
                />
              </Card>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default FamiliesAndFormulas;

const Title = styled.h2`
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  font-weight: 300;
  color: #2E384D;
  width: 10%;
  text-wrap: nowrap
`;
